import { useField } from "formik";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

type Props = {
  name: string;
  label: string;
  maxDate?: any;
  minDate?: any;
  sx?: any;
  isReadOnly?: boolean;
  handleOnChange?: any;
  [rest: string]: any;
};

const FormikDatePicker = ({
  name,
  label,
  maxDate,
  minDate,
  sx,
  isReadOnly,
  handleOnChange,
  ...rest
}: Props) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (date: Date | null) => {
    if (date) {
      date.setHours(0, 0, 0, 0);
      helpers.setValue(date);
    }
    if (handleOnChange) {
      handleOnChange();
    }
  };

  return (
    <DatePicker
      maxDate={maxDate ? dayjs(maxDate).toDate() : undefined}
      minDate={minDate ? dayjs(minDate).toDate() : undefined}
      label={label}
      value={field.value || null}
      onChange={handleChange}
      readOnly={isReadOnly}
      slotProps={{
        textField: {
          ...rest,
        },
      }}
    />
  );
};

export default FormikDatePicker;
